import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { supabase } from "./supabase";
import type { Tables, TablesInsert } from "./database.types";

export type Lancamento = Tables<"lancamentos">;
export type TipoAtividade = Tables<"tipos_atividade">;

export function useTiposAtividade() {
  return useQuery({
    queryKey: ["tipos_atividade"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("tipos_atividade")
        .select("*")
        .eq("ativo", true)
        .order("ordem");
      if (error) throw error;
      return data;
    },
  });
}

export function useLancamentos(ano: number) {
  return useQuery({
    queryKey: ["lancamentos", ano],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("lancamentos")
        .select("*")
        .gte("data", `${ano}-01-01`)
        .lte("data", `${ano}-12-31`)
        .order("data");
      if (error) throw error;
      return data;
    },
  });
}

export function useSalvarLancamento() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (registro: TablesInsert<"lancamentos">) => {
      const { data, error } = await supabase
        .from("lancamentos")
        .upsert(registro)
        .select()
        .single();
      if (error) throw error;
      return data;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["lancamentos"] }),
  });
}

export function useExcluirLancamento() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const { error } = await supabase.from("lancamentos").delete().eq("id", id);
      if (error) throw error;
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["lancamentos"] }),
  });
}
